<template>
    <div>
        <div class="rootdiv">
        
    <topmenu></topmenu>

    
    <div class="container theme-showcase">
        <div style="margin-top: 20px; display: flex; align-items: center;">
                <!-- <div>
                    <el-page-header @back="goBack" title="Back">
                    </el-page-header>
                </div> -->
                <div>
                    <el-button type="primary" icon="el-icon-plus" size="medium" @click="add">Add</el-button>
                </div>
                <div style="margin-left: 12px;">
                    <el-select v-model="eventId" size="medium" placeholder="Select" @change="eventChange">
                        <el-option v-for="item in eventList" :key="item.id" :label="item.eventName" :value="item.id">
                        </el-option>
                    </el-select>
                </div>

            </div>

            <div style="margin: 16px 0;">
                <el-table :data="list" border style="width: 100%">
                    <el-table-column prop="index" label="No" width="60" fixed="left">
                    </el-table-column>
                    <el-table-column prop="eventName" label="Event Name" min-width="100">
                    </el-table-column>
                    <el-table-column prop="typeName" label="type Name" min-width="100" width="120">
                    </el-table-column>
                    <el-table-column prop="visitorCateName" label="Visitor CateName" min-width="100">
                    </el-table-column>
                    <el-table-column prop="subject" label="Subject" min-width="300">
                    </el-table-column>



                    <el-table-column label="Edit" fixed="right" min-width="60">
                        <template slot-scope="scope">
                            <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)" size="mini"></el-button>
                                <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)" size="mini"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

    </div>
</div>
    </div>
    
</template>

<script>
import axios from 'axios'
import topmenu from '../home/components/topmenu'

export default {
    name: 'emailtemplist',
    components: {topmenu },
    data() {
        return {
            eventId:0,
            list:[],
            eventList:[],
        }
    },
    methods: {
        loadData() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/EmailTemp/getList',
                {
                    eventId: this.eventId,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.total = res.total;
                this.list = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        add(){
this.$router.push('/addemailtemp?eid='+this.eventId);
        },
        loadEvent() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/event/getList',
                {
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadEventSucc)
        },
        loadEventSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list && res.list.length > 0) {
                    this.eventList = res.list;
                    console.log(this.eventList);
                    if (this.eventId == '' || this.eventId == 0) {
                        this.eventId = res.list[0].id;
                    }
                        this.loadData();
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        eventChange(id) {
            console.log(id);
            localStorage.setItem('eventId',id);
            this.currentPage = 1;
            this.loadData();
        },
        handleEdit(index, row) {
            console.log(index, row);
            var id = row.id;
        console.log(id);
this.$router.push('/addemailtemp?eid='+this.eventId+'&id='+id);
        },
        handleDelete(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);

            this.$confirm('This will permanently delete the data. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.delCate(id);
            });

        },

        delCate(id){
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/EmailTemp/deleteCategory',
                {
                    id:id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.delCateSucc)
        },
        delCateSucc(res){
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData();
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

    },
    mounted() {
        var eventId = localStorage.getItem('eventId');
        if(eventId!=null && eventId!=undefined){
            eventId = parseInt(eventId);
            this.eventId=eventId;
        }
        this.loadEvent();
    },
    beforeDestroy() {
        
    }
}
</script>


<style scoped>
.rootdiv >>> .topmenuitem:nth-child(7){
    color: #fff;
 background-color: #080808;
}
</style>



// WEBPACK FOOTER //
// src/pages/emailtemp/emailtemplist.vue